import { type FiltersState, createFiltersSlice } from "features/Application/slices/createFiltersSlice";
import ReducerNamespaceTypes from "../../../../../enums/reducer/reducerNamespaceTypes";
import ReducerEntityPrefixTypes from "../../../../../enums/reducer/reducerEntityPrefixTypes";

const initialFilterState: FiltersState<string> = {
  appliedFilter: {},
  filterOptions: {},
  isLoading: false,
};

const groupAssignmetFilterSlice = createFiltersSlice({
  initialState: initialFilterState,
  namePayload: {
    name: "groupAssignmentFilters",
    namespace: ReducerNamespaceTypes.Library,
    entity: ReducerEntityPrefixTypes.Group_Assignments,
  },
  reducers: {},
});

export const { setAppliedFilter, resetAppliedFilter, setSearch, resetSearch } = groupAssignmetFilterSlice.actions;

export default groupAssignmetFilterSlice.reducer;
